import React, { useState, useEffect } from "react";

/*
        {rssTitles.length > 0 && (
          <div className="rss-marquee">
            <div>{rssTitles.join(" | ")}</div>
          </div>
        )}
*/
const FooterSponsors = () => {
    return <footer className="footer">

        <img
          src="/logo-cycling-vlaanderen-horizontal.svg"
          alt="Cycling Vlaanderen Logo"
          className="footer-logo"
        />
        <div style={{ margin: "10px 0" }}>
          <img
            src="/logo-sport-vlaanderen.png"
            alt="Sport Vlaanderen Logo"
            className="footer-logo"
            style={{ padding: "0px 15px" }}
          />
        </div>
        <img src="/logo-belgian-cycling.svg" alt="Belgian Cycling Logo" className="footer-logo" />
        <p className="poweredBy">Powered by technology of IDLab<br/>(UGent-imec)</p>
      </footer>
}

export default FooterSponsors;
